//
//  Terms.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Box, Button, Stack } from "@mui/material";
import { ReactElement } from "react";
import IsnLogo from "./component/IsnLogo";
import {
  OFFICIAL_WEB_SITE_NAME,
  OFFICIAL_WEB_SITE_URL,
  TERMS_PAGE_TEXT,
} from "./utils/env";

const Terms = (): ReactElement => {
  return (
    <>
      <IsnLogo />
      <center>
        <h1>プライバシーポリシー・利用規約について</h1>
        <body style={{ maxWidth: "660px", margin: "0 auto" }} className="text">
          {TERMS_PAGE_TEXT}
        </body>
        <Box sx={{ m: 5 }}>
          <a href={OFFICIAL_WEB_SITE_URL}>{OFFICIAL_WEB_SITE_NAME}</a> /{" "}
          <a href="/">トップページに戻る</a>
        </Box>
      </center>
    </>
  );
};

export default Terms;
